// extracted by mini-css-extract-plugin
export default {"Container":"style_Container__gI8sT","LoadingScreenWithHeader":"style_LoadingScreenWithHeader__jfQmX","Loader":"style_Loader__YDf7D"};